import {
  SbBlokData,
  StoryblokServerComponent,
} from "@storyblok/react/rsc";
import React from "react";
import { SectionStoryblok } from "@/component-types-sb";
import { StoryblokComponentData } from "@/components/Page";
import SectionWrapper from "./SectionWrapper";

const Section: React.FunctionComponent<{ blok: SectionStoryblok; data?: StoryblokComponentData }> = ({ blok, data }) => {
  return (
    <SectionWrapper blok={blok} data={data}>
      {blok?.body?.map((nestedBlok: SbBlokData) => (
        <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} data={data} />
      ))}
    </SectionWrapper>
  );
};

export default Section;
